import React from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../../Hooks";
import useStyles from "./FmCompletedPercentage.style";
import { HUNDRED, ZERO } from "../../../../Utils/Consts";

interface FmCompletedPercentageProps {
    percentage: number | null;
}

const FmCompletedPercentage = ({ percentage }: FmCompletedPercentageProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const percent = percentage ? percentage : ZERO;
    const percentage_color =
        percent === HUNDRED
            ? isMobile
                ? classes.mobile_percentage_green
                : classes.percentage_green
            : isMobile
            ? classes.mobile_percentage_red
            : classes.percentage_red;

    return (
        <div className={isMobile ? classes.mobile_container : classes.container}>
            <span className={isMobile ? classes.mobile_leftText : classes.leftText}>{t("pageStep5.completePercentage")}</span>
            <span className={percentage_color}>
                {percentage}
                <span className={isMobile ? classes.mobile_sign : classes.sign}>%</span>
                {isMobile && (
                    <span className={classes.smallText}>
                        {t("pageStep5.missing")} {HUNDRED - percent}%
                    </span>
                )}
            </span>
        </div>
    );
};

export default FmCompletedPercentage;
